import { Container } from 'react-bootstrap';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMap } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import clsx from 'clsx';

import RiverSiteMap from './RiverSiteMap.jsx';
import Placeholder from './Placeholder.jsx';
import { getContainerWidth } from '../helpers/BootstrapGrid.js';

import styles from './MapPageHeader.module.css';

const MAP_PADDING = {left: 60, right: 80 , top: 50, bottom: 90};

function MapPageHeader({riverKey, geometry, sites, allData, pageTitle, goToSite}) {
  return (
    <div className={styles.MapPageHeader}>
      <div className={styles.MapPageHeaderMapArea} >
        <RiverSiteMap
          className={styles.MapPageHeaderMap}
          geometry={geometry}
          sites={sites}
          allData={allData}
          padding={MAP_PADDING}
          goToSite={goToSite}
          style={{width: '100%', height: '450px'}}
          mapSize={function(mapDimensions) { return [getContainerWidth(window.innerWidth), mapDimensions.height]; }}
        />
      </div>
      <div className={styles.MapPageHeaderOverlayContainer}>
        <Container className={styles.MapPageHeaderOverlay}>
          <h1>
            <Placeholder ready={pageTitle} xs={3}>
              {pageTitle}
            </Placeholder>
          </h1>
        </Container>
      </div>
      <div className={clsx(styles.MapPageHeaderToolContainer, 'd-block d-sm-none')}>
        <Link to={`/rivers/${riverKey}/map`} className={clsx('btn', 'btn-sm', 'btn-dark', styles.MapPageHeaderButton)}>
          <FontAwesomeIcon icon={faMap}/>
          <span>Map View</span>
        </Link>
      </div>
    </div>)
}

export default MapPageHeader
